<script>
  import Illustration from "./Illustration.vue";

  export default {
    components: { Illustration },
    methods: {
      goToProfile() {
        this.$router.push({ name: "profile" });
      },
    },
  };
</script>
<template>
  <div
    class="d-flex align-items-center justify-content-center content-container"
  >
    <div class="col-12 col-md-6 col-xl-4 d-flex flex-column align-items-center justify-content-center gap-24 w-100">
      <Illustration />

      <div class="text-center">
        <h4 class="heading-4-bold text-neutral-900">
          {{ $t("messages.profileReviewStatus") }}
        </h4>
        <p class="p-base-regular text-neutral-500 m-t-12">
          {{ $t("messages.profileReviewStatusHint") }}
        </p>
      </div>
    </div>
  </div>
</template>
<style lang="sass" scoped>
.content-container
  height: calc(100vh - 128px)
</style>
